<template>
  <!-- 异常预案 -->
  <div class="plan">
    <el-form class="bginput" style="margin-bottom: 0.8rem;" label-width="8rem">
      <el-form-item label="异常预案数据">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-select v-model="set.getType" placeholder="请选择">
              <el-option label="手动录入" :value="0"></el-option>
              <el-option label="后台获取" :value="1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button @click="add" size="small" type="success">添加数据</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-form v-for="(item,i) of tableData" :key="i" style="margin-bottom: 0.8rem;" class="bginput1" label-width="6rem">
      <el-row :gutter="0">
        <el-col :span="10">
          <el-form-item label="预案名称">
            <el-input v-model="item.name" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="10">
          <el-form-item label="预案等级">
            <el-select v-model="item.level" placeholder="请选择">
              <el-option label="1级" :value="1"></el-option>
              <el-option label="2级" :value="2"></el-option>
              <el-option label="3级" :value="3"></el-option>
              <el-option label="4级" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="2">
          <i @click="del(item, i)" class="el-icon-remove-outline" style="font-size: 1rem;line-height: 1.8rem;color: #f00;font-weight: 600;margin-left: 1rem;cursor: pointer;"></i>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="10">
          <el-form-item label="总指挥">
            <el-input v-model="item.chief" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="救援方式">
            <el-select v-model="item.type" placeholder="请选择">
              <el-option label="内部救援" :value="0"></el-option>
              <el-option label="消防救援" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="10">
          <el-form-item label="疏散时长">
            <el-input type="number" v-model="item.times" placeholder="请录入数字">
              <template slot="suffix">分钟</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="灭火负责人">
            <el-input v-model="item.fightingLeader" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="10">
          <el-form-item label="疏散范围">
            <el-input v-model="item.evacuate" placeholder="请录入"><template slot="suffix">米</template></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="灭火队员">
            <el-input v-model="item.fightingTeam" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="10">
          <el-form-item label="疏散负责人">
            <el-input v-model="item.evacuateLeader" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后勤负责人">
            <el-input v-model="item.evacuateTeam" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="0">
        <el-col :span="10">
          <el-form-item label="疏散队员">
            <el-input v-model="item.logisticsLeader" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="后勤队员">
            <el-input v-model="item.logisticsTeam" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="20">
          <el-form-item label="预案内容">
            <el-input v-model="item.content" placeholder="请录入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <div style="margin-top: 2rem;">
      <el-button @click="save" size="small" type="primary">保存数据</el-button>
    </div>

  </div>
</template>

<script>
import api from '@/apis/safety/plan'
export default {
  data() {
    return {
      set: {
        getType: 0,
      },
      formData: {},
      tableData: [],
    }
  },
  mounted() {
    this.getlist()
  },

  methods: {
    add() {
      this.tableData.unshift({
        chief: '', //总指挥
        content: '', //内容
        evacuate: '', //疏散范围
        evacuateLeader: '', //疏散队长
        evacuateTeam: '', //疏散队员
        fightingLeader: '', //灭火队长
        fightingTeam: '', //灭会队员
        level: 1, //预案等级
        logisticsLeader: '', //后勤队长
        logisticsTeam: '', //后勤队员
        name: '', //预案名称
        times: '', //疏散时长
        type: '', //0自己灭火 1：消防大队打电话
        unit: '', //单位
      })
    },
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            if (res.data.length) {
              this.tableData = res.data
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },

    save() {
      api.save(this.tableData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.getlist()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    del(item, i) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {
          for (const iterator of this.tableData) {
            if (iterator.id === undefined) {
              return this.$message.warning(
                '还有未保存的数据,请先保存后再删除！'
              )
            }
          }
          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
            this.getlist()
          })
        } else {
          this.tableData.splice(i, 1)
        }
      })
    },
  },
}
</script>

<style lang="less">
.plan {
  padding-top: 10px;
  .el-form-item {
    margin-bottom: 0;
  }
  .bginput1 {
    width: 45%;
    display: inline-block;
    border: #3570ff solid 1px;
    padding: 1rem;
    margin-right: 1rem;
  }
}
</style>